import { render, staticRenderFns } from "./resource_new.vue?vue&type=template&id=6c62785e&scoped=true&"
import script from "./resource_new.vue?vue&type=script&lang=js&"
export * from "./resource_new.vue?vue&type=script&lang=js&"
import style0 from "./resource_new.vue?vue&type=style&index=0&lang=css&"
import style1 from "./resource_new.vue?vue&type=style&index=1&id=6c62785e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c62785e",
  null
  
)

export default component.exports